interface DataNotFoundProps {
  className?: string
}

function DataNotFound({ className = '' }: DataNotFoundProps) {
  return (
    <div className={`${className} w-full grid content-center`}>
      <div className='flex flex-col items-center'>
        <span className='material-icons w-[5vh] h-[5vh] text-[5vh] text-center'>query_stats</span>
        <span className='text-center pt-8 font-semibold'>データが見つかりませんでした</span>
      </div>
    </div>
  )
}

DataNotFound.defaultProps = {
  className: '',
}

export default DataNotFound
